module.exports = __webpack_public_path__ + "static/img_9995_dpp_optimized-99663a54ae67e785375a912cb964aca6.jpg";